export const AI_ASSISTANT_SIDEBAR_WIDTH_CSS_VARIABLE = '--dms-assistant-sidebar-width';
